import { Phone } from "lucide-react";
import { CONTACT } from "../mock";
import { WhatsappIcon } from "./ui-kit";

const StickyCta = () => (
  <div className="fixed z-40 bottom-6 left-5 sm:left-6 flex flex-col gap-3" data-testid="sticky-cta">
    <a
      href={CONTACT.whatsappHref}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="WhatsApp Sipariş Hattı"
      data-testid="sticky-whatsapp"
      className="group relative w-14 h-14 rounded-full bg-[#25D366] text-white shadow-[0_14px_34px_rgba(37,211,102,0.4)] flex items-center justify-center hover:bg-[#1ebe5b] transition-colors"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30 group-hover:opacity-0" />
      <WhatsappIcon size={24} />
    </a>
    <a
      href={CONTACT.phoneHref}
      aria-label="Bizi arayın"
      data-testid="sticky-call"
      className="w-14 h-14 rounded-full bg-ink text-white shadow-[0_14px_34px_rgba(26,26,26,0.28)] flex items-center justify-center hover:bg-brand transition-colors"
    >
      <Phone size={21} strokeWidth={1.9} />
    </a>
  </div>
);

export default StickyCta;
